// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__fNMX-","label":"CategoryService_label__2TenK","location":"CategoryService_location__BSOBB"};